export enum CaptchaActionsEnum {
  CAPTCHA_SET_ERROR = 'CAPTCHA_SET_ERROR',
  CAPTCHA_SET_IS_ACTIVE = 'CAPTCHA_SET_IS_ACTIVE',
  CAPTCHA_LOAD = 'CAPTCHA_LOAD',
  CAPTCHA_REQUEST = 'CAPTCHA_REQUEST',
  CAPTCHA_SUCCESS = 'CAPTCHA_SUCCESS',
  CAPTCHA_SET_IMAGE = 'CAPTCHA_SET_IMAGE',
  CAPTCHA_GET_IMAGE = 'CAPTCHA_GET_IMAGE',
  CAPTCHA_RESET = 'CAPTCHA_RESET',
  CAPTCHA_SET_ACTION_AFTER_LOAD = 'CAPTCHA_SET_ACTION_AFTER_LOAD',
  CAPTCHA_GET_AUDIO = 'CAPTCHA_GET_AUDIO',
  CAPTCHA_SET_AUDIO = 'CAPTCHA_SET_AUDIO',
}
